import qs from "qs";
// import { type } from "os";

export const geocodeKey = "AIzaSyDOikYPJlWzZwbEIZqdqAk9P2cQqw4DGEw";

const baseUrl = "https://maps.googleapis.com/maps/api/geocode/json";

export async function geocodeCoords(lat, lng) {
  // let fetchData = await fetch( `${baseUrl}?${qs.stringify({ latlng: `${lat},${lng}`, key: geocodeKey })}`);
  // let response = await (fetchData).json();
  // await new Promise((resolve, reject) => {
  //   setTimeout(resolve, 3000); 
  // } ).catch( (reject) =>{
  //     reject()
  //   }
  // );
  
  // return response;

  return new Promise(function(resolve, reject) {
      let didTimeOut = false;
      let response = [];
      const timeout = setTimeout(function() {
          didTimeOut = true;
          console.log('TIME OUT');
          resolve( response );
          reject();
      }, 3000 );
      fetch(`${baseUrl}?${qs.stringify({ latlng: `${lat},${lng}`, key: geocodeKey })}`)
      .then(response =>response.json() )
      .then(function(response) {
          // Clear the timeout as cleanup
          clearTimeout(timeout);
          if(!didTimeOut) {
            resolve( response );
          }
      })
      
      .catch(function(err) {
          // Rejection already happened with setTimeout
          if(didTimeOut) return;
          // Reject with error
          reject(err);
      });
  })
}



// WEBPACK FOOTER //
// ./src/backend/geocode.js